import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Routes } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CategoriesTree, Category, User } from 'src/app/_models';
import { AuthenticationService, CatalogService, HeaderService } from 'src/app/_services';
import { ApplicationStateService } from 'src/app/_services/application-state.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-promos',
  templateUrl: './promos.component.html',
  styleUrls: ['./promos.component.css']
})
export class PromosComponent implements OnInit {

  private currentUser : User;
  private categoryId : string;
  public base_image_url : string;

  constructor(
    private auth : AuthenticationService,
    public catalog : CatalogService,
    public translate : TranslateService,
    private route : ActivatedRoute,
    private header : HeaderService,
    public apps : ApplicationStateService,
    public dom : DomSanitizer,
    
  ) { 
    this.header.setHeader(false,false,true,true);

    this.base_image_url = environment.BASE_IMAGE_URL;
    
    this.auth.currentUser.subscribe( currentUser  => {
      this.currentUser = currentUser;
      this.catalog.currentCategory = null;
      this.catalog.filtered = false;


      this.route.params.subscribe( result => {
        this.categoryId = this.route.snapshot.params.categoryId;
        this.loadData();
      });
      
    });




  }

  ngOnInit() {
    

  }

  ngOnChanges() {
    if ( this.categoryId ){
      this.loadData();
    } 
    this.header.scrollTop();
  }


  loadData (){
    
    this.catalog.getTree( this.auth.isLogedUser).subscribe( result =>  {
      this.catalog.currentCategory =  this.catalog.Tree.getCategory(this.categoryId);
    });

  }

}
